/* OM Boots Ultra Anleitung – Design-Layer v2 (Okt 2026).
   Lädt NACH om-boots-ultra-guide.js. Ersetzt nur die Zonen-Grafik (Produktfoto mit Pins)
   und ein paar Texte. Die Tour-/Display-Logik bleibt unverändert. */
'use strict';
(function(){
  if(typeof anatomySvg!=='function'||typeof renderOverview!=='function'||typeof renderHelp!=='function')return;
  var ZONE_IMG=(typeof OM_BOOT_GUIDE_ASSETS!=='undefined'&&OM_BOOT_GUIDE_ASSETS['om-boots-ultra-guide-22.webp'])||'';
  var PINS=[[37,90],[42,73],[44,56],[45,39],[44,23],[38,7]];
  var TEXTS=[
    ['So ist deine Hose aufgebaut.','So sind deine Boots aufgebaut.'],
    ['Schematische Darstellung · Nummerierung vom Fuß aufwärts','Tippe auf eine Zahl · Nummerierung vom Fuß (1) zum Bauch (6)'],
    ['Bedienungsanleitung · Aufbau, Bedienoberflächen und Einstellungen, Seiten 26–52','Grundlage: Bedienungsanleitung OM Recovery Boots Ultra'],
    ['Grundlage: Bedienungsanleitung · Seiten 26–52','Grundlage: Bedienungsanleitung OM Recovery Boots Ultra'],
    ['Nutze den Zurück-Pfeil, um zum nächsten Tour-Schritt zurückzukehren.','Tippe auf den Zurück-Pfeil, um zum Hauptbildschirm zurückzukehren.']
  ];
  function patch(root){
    if(!root)return;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),n;
    while((n=w.nextNode())){
      var t=n.nodeValue,c=t;
      for(var i=0;i<TEXTS.length;i++)if(c.indexOf(TEXTS[i][0])!==-1)c=c.split(TEXTS[i][0]).join(TEXTS[i][1]);
      if(c!==t)n.nodeValue=c;
    }
  }
  anatomySvg=function(){
    var pins=PINS.map(function(p,i){
      return '<button class="zone-pin '+(anatomyZone===i?'selected':'')+'" style="left:'+p[0]+'%;top:'+p[1]+'%" data-anatomy="'+i+'" aria-pressed="'+(anatomyZone===i)+'" aria-label="Zone '+(i+1)+', '+ZONES[i]+', maximal '+MAX[i]+' mmHg">'+(i+1)+'</button>';
    }).join('');
    return '<div class="anatomy-photo"><img src="'+ZONE_IMG+'" width="480" height="1485" alt="OM Recovery Boots Ultra, ein Bein: Zone 1 am Fuß bis Zone 6 am Bauch">'+pins+'</div>';
  };
  var _renderOverview=renderOverview;
  function reverseZoneList(){var l=document.querySelector('#overview .zone-list');if(!l||l.dataset.rev)return;Array.prototype.slice.call(l.children).reverse().forEach(function(c){l.appendChild(c)});l.dataset.rev='1';}
  renderOverview=function(){var r=_renderOverview.apply(this,arguments);patch(document.getElementById('overview'));reverseZoneList();return r;};
  var _renderHelp=renderHelp;
  renderHelp=function(){var r=_renderHelp.apply(this,arguments);patch(document.getElementById('help'));patch(document.getElementById('display-instruction'));patch(document.getElementById('mobile-help-dock'));return r;};
  renderOverview();renderHelp();
})();

/* Schnellstart-Video: Kapitelmarken + Buttons (reine Ergänzung) */
(function(){
  var v=document.getElementById('qs-player');if(!v)return;
  function fmt(){var btns=document.querySelectorAll('[data-qs-seek]'),t=v.currentTime,cur=null;btns.forEach(function(b){if(t>=Number(b.dataset.qsSeek))cur=b});btns.forEach(function(b){b.classList.toggle('active',b===cur)});}
  document.addEventListener('click',function(e){
    var seek=e.target.closest('[data-qs-seek]');
    if(seek){v.currentTime=Number(seek.dataset.qsSeek);v.play().catch(function(){});fmt();return}
    if(e.target.closest('[data-qs-next]')){v.pause();var o=document.getElementById('overview');if(o)o.scrollIntoView({block:'start',behavior:'smooth'});return}
    if(e.target.closest('[data-qs-tour]')){v.pause();if(typeof startOriginalGuide==='function')startOriginalGuide('easy');return}
  });
  v.addEventListener('timeupdate',fmt);
})();
